function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty2(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty2(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { Controller } from 'stimulus';
import Sortable from 'sortablejs';
import Rails from '@rails/ujs';

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

class _class extends Controller {
  initialize() {
    this.end = this.end.bind(this);
  }

  connect() {
    this.sortable = new Sortable(this.element, _objectSpread(_objectSpread({}, this.defaultOptions), this.options));
  }

  disconnect() {
    this.sortable.destroy();
    this.sortable = undefined;
  }

  end(_ref) {
    let item = _ref.item,
        newIndex = _ref.newIndex;
    if (!item.dataset.sortableUpdateUrl || !window._rails_loaded) return;
    const resourceName = this.resourceNameValue;
    const paramName = this.paramNameValue || 'position';
    const param = resourceName ? `${resourceName}[${paramName}]` : paramName;
    const data = new FormData();
    data.append(param, newIndex + 1);
    Rails.ajax({
      url: item.dataset.sortableUpdateUrl,
      type: 'PATCH',
      data
    });
  }

  get options() {
    return {
      animation: this.animationValue || this.defaultOptions.animation || 150,
      handle: this.handleValue || this.defaultOptions.handle || undefined,
      onEnd: this.end
    };
  }

  get defaultOptions() {
    return {};
  }

}

_defineProperty(_class, "values", {
  resourceName: String,
  paramName: String,
  animation: Number,
  handle: String
});

export default _class;